import * as React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { PageTitle } from '../../../../../widgets/PageTitle';
import Viewport from '../../../../../widgets/Viewport';
import ViewHeader from '../../../../../widgets/ViewHeader';
import { OnboardingSensorForm } from './Form';
import { ROUTE_PATH } from '../../../../../constants';
import {
  BAD_MODEL_RECOMMENDATIONS,
  EMPTY_SENSOR,
  fetchRecommendedModel,
  getSensorModelFromFormValues,
  SensorFormValues,
} from './constants';
import { ONBOARDING_ACTIONS } from '../../../../../actions/onboarding';
import { apiRequest } from '../../../../../APIClient';
import { useDispatch, useSelector } from 'react-redux';
import { createSensorScannerValidationSchema } from '../../../validationSchemas';
import { Formik } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import { onboardingSelector } from '../../../../../reducers/onboarding';
import { ScrollSectionKeys } from '../../OnboardingSiteConfig';

export const OnboardingSensorAddView: React.FunctionComponent = () => {
  const genericSeriesEnabled = useSelector(
    onboardingSelector.showGenericSeries,
  );
  const dispatch = useDispatch();

  const sensorCapabilities = useSelector(
    onboardingSelector.getSensorCapabilities,
  );

  const onSubmitSensor = React.useCallback(
    async (values: SensorFormValues) => {
      const sensor = getSensorModelFromFormValues(values);
      const uuid = uuidv4();
      if (genericSeriesEnabled && !sensor.modelChanged) {
        const recommendedModel = await fetchRecommendedModel(sensor);
        if (!BAD_MODEL_RECOMMENDATIONS.includes(recommendedModel)) {
          sensor.model = recommendedModel;
        }
      }
      dispatch(ONBOARDING_ACTIONS.ADD_SENSOR(sensor, uuid));
      dispatch(apiRequest.saveOBSensors());
    },
    [dispatch, genericSeriesEnabled],
  );
  const [currentSeries, setCurrentSeries] = React.useState('');

  const sensorNames = useSelector(onboardingSelector.getSensorNames);
  const validationSchema = React.useMemo(
    () =>
      createSensorScannerValidationSchema({
        genericSeriesEnabled,
        schemas: sensorCapabilities[currentSeries],
        existingNames: sensorNames,
      }),
    [currentSeries, genericSeriesEnabled, sensorCapabilities, sensorNames],
  );

  return (
    <Viewport>
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to={ROUTE_PATH.ONBOARDING.MAIN}>Onboarding Overview</Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Configure Sensor</BreadcrumbItem>
      </Breadcrumb>
      <PageTitle title="Configure Sensor" />
      <ViewHeader title="Configure Sensor" />
      <Formik
        innerRef={(e) => {
          setCurrentSeries(e?.values?.series ?? '');
        }}
        initialValues={EMPTY_SENSOR}
        onSubmit={onSubmitSensor}
        validationSchema={validationSchema}
      >
        <OnboardingSensorForm showSaveAndAdd view={ScrollSectionKeys.SENSORS} />
      </Formik>
    </Viewport>
  );
};
